// @flow

const responseIsValid = (response: ProductsResponse) => !!response?.productCategoryFacetedSearch?.totalItemCount;

const parseTotalItemCount = (response: ProductsResponse) => (
    responseIsValid(response) ? Number(response.productCategoryFacetedSearch.totalItemCount) : 0
);

export default parseTotalItemCount;
